import { css } from "styled-components";

export const DataTableStyles = css(({ theme }) => ({
    ".PaginatedTable.TableRoot": {
        "&&": {
            ".TableHead": {
                boxShadow: `0px 0px 5px 0px ${theme.palette.overlays[900][12]}`,
            },
        },
    },
}));
